import { createContext } from "react";

interface ApplyWithSeekContextValue {
  applyWithSeekEnabled: boolean;
}

export const ApplyWithSeekContext = createContext<ApplyWithSeekContextValue>({
  applyWithSeekEnabled: false,
});
